import * as React from "react";

import "./folder-templates-route.scss";

import {cs}               from "@Common/react/chain-services";
import {consumeContext}   from "@Common/react/context";
import {Load2}            from "@Common/react/load2";
import {rLsStore}         from "@Common/react/ls-store";
import {UseState}         from "@Common/react/use-state";
import {Responsive}       from "@Common/ui-components/responsive";
import {reverse, sort}    from "@Common/utils/collections";
import {chain}            from "@Common/utils/fs";
import {faSpinner}        from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon}  from "@fortawesome/react-fontawesome";

import {Breadcrumbs}      from "../../common/breadcrumbs/breadcrumbs";
import {TemplateListMode} from "../../common/components/template-list-mode/template-list-mode";
import {rTemplates}       from "../../common/components/templates/templates";
import {Layout}           from "../../layout/layout";

const templatesPerLoad = 50;
export const FolderTemplatesRoute = ({match}) => cs(
    consumeContext("apis"),
    ["folder", ({apis}, next) => Load2({
        fetch: () => apis.next.userCreated.getFolder( match.params.folder_id ),
        next,
    })],
    ["folderTemplates", ({apis}, next) => Load2({
        fetch: () => apis.next.userCreated.getTemplates( match.params.folder_id, 1 ),
        next,
    })],
    ["more", (_, next) => UseState({
        initValue: templatesPerLoad,
        next,
    })],
    ["reversed", (_, next) => UseState({
        next,
    })],
    // @ts-ignore
    ["responsive", (_, next) => <Responsive {...{
        sizes: {
            md: 1024,
        },
        next,
    }}/>],
    ["viewMode", ({responsive}, next) => responsive.lt("md") ? next({value: "large"}) : rLsStore("tiles.viewMode", "medium")({}, next)],
    ({folder, folderTemplates, reversed, viewMode, more}: {
        folder,
        folderTemplates,
        reversed,
        viewMode,
        more

    }) => {
        return (
            <Layout className="folder-templates-route-8sh" active="catSubcatStyle">
                <div className="restrict-width-1">
                    <Breadcrumbs
                        userCreated={true}
                        folder={!folder.loading && folder.value}
                    />

                    <div className="controls">
                        <div className="view-modes">
                            {TemplateListMode(viewMode)}
                        </div>
                    </div>

                    {folderTemplates.loading ? (
                        <div className="spinner-footer" xd-qa-type="label" xd-qa-name="Loading">
                            <FontAwesomeIcon icon={faSpinner} className="fa-pulse"/>
                        </div>
                    )  : !folderTemplates.value.length ? (
                        <div className="" xd-qa-type="label" xd-qa-name="Empty">
                            No templates are available in this folder!
                        </div>
                    ) : <>
                        {rTemplates(
                            chain(
                                folderTemplates.value,
                                // @ts-ignore
                                (_) => sort(_, (t) => t.seq),
                                (_) => reversed.value ? reverse(_) : _,
                                (_) => _.slice(0, more.value),
                            ),
                            {subId: () => match.params.sub_id, mode: viewMode.value, catId: () => match.params.cat_id, userCreated: true}
                        )}
                        {more.value < folderTemplates.value.length && (
                            <div className="load-more">
                                <button
                                    onClick={()=> more.change(v=>v+templatesPerLoad)}
                                >
                                    Load More
                                </button>
                            </div>
                        )}
                    </>}
                </div>
            </Layout>
        );
    },
);

